import { localAdConfig } from "../app/core/auth/config/keys";

export const environment = {
    production: false,
    adConfig: {
        clientId: localAdConfig.clientId,
        authority: localAdConfig.authority,
        redirectUri: localAdConfig.redirectUri,
        postLogoutRedirectUri: localAdConfig.postLogoutRedirectUri,        
        navigateToLoginRequestUrl: true
    },
    api: {
        baseUrl: '/api',
        scopes: ['api://d0df8d6f-d0c6-4cce-a050-1955af941126/access_as_user']
    },
    msGraph: {
        baseUrl: 'https://graph.microsoft.com/v1.0',
        scopes: ['user.read']
    }

}
